<template>
<div class="chapter">
<div class="inner_page">
<div id="Maps_Diagrams">
<p class="fm-title"><a id="page_vii"><b>Maps &amp; Diagrams</b></a></p><a id="page_vii">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="5%"/>
<col width="95%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para"><span href="#/xhtml/18_Chapter11#map_1" title="Link target outside of Sample">Map 1:</span></p></td>
<td align="left" valign="top"><p class="table-para1"><span href="#/xhtml/18_Chapter11#map_1" title="Link target outside of Sample">Edirne (Adrianople) with distances to probable battlefield locations</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><span href="#/xhtml/18_Chapter11#dia_1" title="Link target outside of Sample">Diagram 1:</span></p></td>
<td align="left" valign="top"><p class="table-para1"><span href="#/xhtml/18_Chapter11#dia_1" title="Link target outside of Sample">Gothic wagon laager in single ring</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><span href="#/xhtml/18_Chapter11#dia_2" title="Link target outside of Sample">Diagram 2:</span></p></td>
<td align="left" valign="top"><p class="table-para1"><span href="#/xhtml/18_Chapter11#dia_2" title="Link target outside of Sample">Gothic wagon laager in concentric rings</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><span href="#/xhtml/18_Chapter11#dia_3" title="Link target outside of Sample">Diagram 3:</span></p></td>
<td align="left" valign="top"><p class="table-para1"><span href="#/xhtml/18_Chapter11#dia_3" title="Link target outside of Sample">Gothic wagon laager in spiral formation</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><span href="#/xhtml/18_Chapter11#dia_4" title="Link target outside of Sample">Diagram 4:</span></p></td>
<td align="left" valign="top"><p class="table-para1"><span href="#/xhtml/18_Chapter11#dia_4" title="Link target outside of Sample">Gothic wagon laager in group formation</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><span href="#/xhtml/18_Chapter11#dia_5" title="Link target outside of Sample">Diagram 5:</span></p></td>
<td align="left" valign="top"><p class="table-para1"><span href="#/xhtml/18_Chapter11#dia_5" title="Link target outside of Sample">Roman deployment in front of Goth wagons with direction of Gothic cavalry attacks displayed</span></p></td>
</tr>
</tbody>
</table>
</a></div><a id="page_vii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Maps_Diagrams.vue?6b32082a